import { CustomerMasterSourceType } from 'generated/bffFinancialInfo/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';

export const api = {
  postNotifyEventPaymentPaymentInfo: (url: string, request: any): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/payment/payment-info`,
      {
        caRefNo: request.caRefNo,
        cuRefNo: request.cuRefNo,
        cpRefNo: request.cpRefNo,
        documentId: request.documentId,
        directProfilePreferredType: request.directProfilePreferredType,
      },
      {
        params: {
          customerMasterSource: CustomerMasterSourceType.O2POP,
          channel: ChannelType.MO2_CARE,
        },
      }
    ),
};
